import React from 'react';
import "./smile-pages.css";

export default function CanSmilingMakeYouLookYounger() {
  return (
    <div className="container-box mt-5 mb-5 smile-page">

      <h1>Can Smiling Make You <u>Look</u> Younger?</h1>

      <p>
        Yes! Smiling makes you look younger by enhancing facial features in a way that conveys 
        <strong> vitality, positivity, and warmth</strong>, while also 
        <strong> masking signs of aging</strong> like wrinkles or sagging skin. 
        The brain also interprets smiling faces as more attractive and youthful — even when 
        age-related features are present.
      </p>

      <p>Here’s the science behind it:</p>

      <hr />

      {/* 1 */}
      <h3>😊 1. Smiling Lifts Your Facial Muscles</h3>

      <p>When you smile:</p>
      <ul>
        <li>
          Muscles like the <strong>zygomaticus major</strong> (which pull up the corners of your mouth) 
          and <strong>orbicularis oculi</strong> (around the eyes) engage.
        </li>
        <li>
          This creates a <strong>natural facelift effect</strong> — lifting the cheeks, brightening 
          the eyes, and reducing sagging skin.
        </li>
      </ul>

      <p>These changes give the face a more <strong>toned, energized, and youthful appearance.</strong></p>

      <hr />

      {/* 2 */}
      <h3>🧠 2. Smiling Causes the Brain to See You as Younger</h3>

      <p>
        Multiple studies have shown that observers tend to judge people who are smiling as 
        <strong> younger</strong> than those with neutral or angry expressions — even when looking at 
        the <strong>same person</strong>.
      </p>

      <p><strong>📚 Study:</strong><br />
        Ganel & Goodale (2018) — Found that smiling 
        <strong> reduced perceived age by several years</strong>, especially compared to frowning 
        or neutral expressions.
      </p>

      <hr />

      {/* 3 */}
      <h3>🌟 3. Smiling Radiates Positivity and Vitality</h3>

      <p>Positive emotional expressions like smiling are closely associated with:</p>

      <ul>
        <li>Health</li>
        <li>Energy</li>
        <li>Friendliness</li>
        <li>Confidence</li>
      </ul>

      <p>
        All of these traits are subconsciously linked to <strong>youthfulness</strong>.  
        A smiling face sends a signal of being  
        <strong> active, engaged, and emotionally vibrant</strong> — key aspects associated 
        with younger people.
      </p>

      <hr />

      {/* 4 */}
      <h3>🤝 4. Smiling Diverts Attention from Wrinkles</h3>

      <ul>
        <li>Distracts attention away from static wrinkles or age spots</li>
        <li>Makes your face appear more dynamic and alive</li>
        <li>Creates positive emotional associations that override visible signs of aging</li>
      </ul>

      <p><strong>📚 Study Insight:</strong><br />
        A 2014 study in <em>Psychonomic Bulletin & Review</em> showed that people were more 
        likely to rate older individuals as <strong>“more youthful”</strong> when they were smiling — 
        despite visible wrinkles.
      </p>

      <hr />

      {/* 5 */}
      <h3>🎭 5. Smiling Enhances Social Perception</h3>

      <p>Smiling people are rated as:</p>

      <ul>
        <li>More approachable</li>
        <li>More trustworthy</li>
        <li>More attractive</li>
      </ul>

      <p>
        These social impressions <strong>boost the perception of youth</strong>, because 
        we associate youth with optimism, friendliness, and warmth — all of which smiling conveys.
      </p>

      <hr />

      {/* SUMMARY */}
      <h3>✅ Summary: Why Smiling Makes You Look Younger</h3>

      <table className="summary-table">
        <thead>
          <tr>
            <th>Factor</th>
            <th>Youthful Effect</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Facial muscle lift</td>
            <td>Creates a natural, mini “facelift”</td>
          </tr>
          <tr>
            <td>Brain perception shift</td>
            <td>Observers judge smiling faces as younger</td>
          </tr>
          <tr>
            <td>Emotional expression</td>
            <td>Radiates vitality, energy, and joy</td>
          </tr>
          <tr>
            <td>Visual distraction</td>
            <td>Draws focus away from wrinkles or aging signs</td>
          </tr>
          <tr>
            <td>Positive social signaling</td>
            <td>Associates you with youth-like qualities</td>
          </tr>
        </tbody>
      </table>

      <hr />

      {/* KEYS */}
      <h3>🔑 Keys to Remember</h3>

      <p>
        <strong>Smiling is a natural beauty enhancer</strong> — smiling softens your face, lifts your 
        features, and sends powerful visual and emotional cues that make you appear more youthful 
        and vibrant. Smiling is one of the simplest, most effective ways to look (and feel) younger — instantly.
      </p>

      <p><strong>That Smile App is here to help you look and feel younger.</strong></p>

    </div>
  );
}
